import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import GiftRuleModalStore from './store';

const styles = require('./index.less');

/** 上线瓜分50万现金红包活动规则弹窗 */
const GiftRuleModal = ({ store, onClose }) => {
  store.use();
  const { title, subTitle, date, rules } = store.ruleConfig;

  if (onClose) {
    store.onClose = onClose;
  }

  React.useEffect(
    () => {
      if (!store.isOpen) return undefined;

      const onKeyDown = event => {
        if (event.key === 'Escape') {
          store.onClickClose();
        }
      };

      document.addEventListener('keydown', onKeyDown);
      return () => document.removeEventListener('keydown', onKeyDown);
    },
    [store.isOpen]
  );

  return (
    <ModalContainer
      modalState={store.isOpen}
      role="dialog"
      aria-modal="true"
      aria-labelledby="gift-rule-title"
      aria-describedby="gift-rule-date gift-rule-content"
      onClick={store.onClickClose}
      style={{ left: '50%', transform: 'translateX(-50%)' }}
    >
      <div className={styles.giftRuleModalRoot} onClick={event => event.stopPropagation()}>
        <h2 id="gift-rule-title" className={styles.title}>
          {title}
        </h2>
        <div className={styles.subTitle}>{subTitle}</div>
        <div id="gift-rule-date" className={styles.date}>
          {date}
        </div>
        <div id="gift-rule-content" className={styles.ruleList} tabIndex="0">
          {rules.map((rule, index) => (
            <p className={styles.ruleItem} key={`${index}-${rule}`}>
              {rule}
            </p>
          ))}
        </div>
        <button type="button" className={styles.closeBtn} onClick={store.onClickClose} aria-label="关闭活动规则弹窗" autoFocus />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(GiftRuleModal, GiftRuleModalStore);
